import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegrationOtp from "../Common/Axios/axiosIntegrationOtp";
export const sendOtpApi = async (payload) => {
  const { data = {} } = await axiosIntegrationOtp.post(API.sendOtp, payload, {
    headers: {
      ClientCode: payload?.clientCode,
      PartnerCode: payload?.partnerCode,
    },
  });
  return data;
};
